import { SharedModule } from '../../shared/shared.module';
import { CategoryAssociationDetailsModule } from './category-association-details/category-association-details.module';
import { CategoryAssociationListModule } from './category-association-list/category-association-list.module';
import { CategoryAssociationComponent } from './category-association.component';
import {NgModule} from '@angular/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { CategoryAssociationNewComponent } from './category-association-new/category-association-new.component';


@NgModule({
  imports: [
    NgbModule,
    SharedModule,
    CategoryAssociationListModule,
    CategoryAssociationDetailsModule
  ],
  declarations: [CategoryAssociationComponent, CategoryAssociationNewComponent],
  exports: [CategoryAssociationComponent],
  entryComponents: [CategoryAssociationNewComponent]
})
export class CategoryAssociationModule {}
